(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-you"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var marquee = document.querySelector('.on-you__marquee');
    if (!marquee) return;
    var track = marquee.querySelector('.on-you__track');
    if (!track || track.classList.contains('on-you__track--static')) return;

    // Respect prefers-reduced-motion — no auto-scroll, user can still scroll manually
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var scrollSpeed = parseFloat(marquee.getAttribute('data-scroll-speed')) || 35;
    var copyCount = parseInt(marquee.getAttribute('data-copy-count'), 10) || 4;

    // Speed in px/s — higher scroll_speed setting = slower (consistent with old mental model)
    var speed = 1000 / scrollSpeed;
    var targetSpeed = speed;
    var currentSpeed = speed;

    // Measure one set of content width
    var singleSetWidth = 0;
    var resizeTimer = null;

    function measure() {
      var cards = track.querySelectorAll('.on-you__card');
      if (cards.length === 0) return;
      var cardsPerSet = Math.round(cards.length / copyCount);
      if (cardsPerSet < 1 || cards.length < cardsPerSet + 1) return;
      // Distance between equivalent cards in adjacent sets — accounts for gaps, margins, everything
      singleSetWidth = cards[cardsPerSet].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }

    measure();

    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 250);
    });

    // Auto-scroll loop with integer accumulator to prevent sub-pixel jitter
    var lastTime = 0;
    var accumulator = 0;
    var running = true;

    function step(timestamp) {
      if (!running) return;
      if (lastTime === 0) lastTime = timestamp;
      var dt = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      // Clamp dt to avoid jumps after tab switch
      if (dt > 0.1) dt = 0.016;

      // Smooth speed interpolation
      currentSpeed += (targetSpeed - currentSpeed) * Math.min(dt * 5, 1);

      if (singleSetWidth > 0) {
        accumulator += currentSpeed * dt;
        // Only scroll whole pixels to avoid jitter
        var px = Math.floor(accumulator);
        if (px > 0) {
          accumulator -= px;
          marquee.scrollLeft += px;

          // Seamless loop reset
          if (marquee.scrollLeft >= singleSetWidth) {
            marquee.scrollLeft -= singleSetWidth;
          }
        }
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    // Desktop hover — smooth deceleration/acceleration (pointer only, not touch)
    marquee.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      targetSpeed = 0;
    });
    marquee.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      targetSpeed = speed;
    });

    // Mobile touch — pause during active touch, resume after release
    var touchTimeout = null;
    marquee.addEventListener('touchstart', function () {
      targetSpeed = 0;
      currentSpeed = 0;
      accumulator = 0;
      if (touchTimeout) clearTimeout(touchTimeout);
    }, { passive: true });
    marquee.addEventListener('touchend', function () {
      if (touchTimeout) clearTimeout(touchTimeout);
      touchTimeout = setTimeout(function () {
        targetSpeed = speed;
      }, 1500);
    }, { passive: true });

    // Video management via IntersectionObserver
    var videos = marquee.querySelectorAll('video');
    if (videos.length > 0) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var video = entry.target;
          if (entry.isIntersecting && video.paused) {
            video.play().catch(function () {});
          } else if (!entry.isIntersecting && !video.paused) {
            video.pause();
          }
        }
      }, { threshold: 0.1 });

      for (var i = 0; i < videos.length; i++) {
        observer.observe(videos[i]);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
